import { PageAsideProps, PageHeaderProps } from '@procore/core-react/dist/_typedoc/PageLayout/PageLayout.types.json';
import * as React from 'react';
export default {
  PageAsideProps,
  PageHeaderProps,
  React
};